(() => {
  const header = document.querySelector('header-component');
  const syncHeader = () => document.body.classList.toggle('sr-scrolled', window.scrollY > 20);
  syncHeader();
  addEventListener('scroll', syncHeader, { passive: true });
  if (header) new ResizeObserver(() => document.documentElement.style.setProperty('--sd-sr-header-height', `${header.offsetHeight}px`)).observe(header);
  const announcementObserver = new ResizeObserver(() => {
    const announcement = document.querySelector('.utility-bar');
    document.documentElement.style.setProperty('--sd-sr-announcement-height', `${announcement ? announcement.getBoundingClientRect().height : 0}px`);
  });
  const observeAnnouncement = () => {
    announcementObserver.disconnect();
    const announcement = document.querySelector('.utility-bar');
    if (announcement) announcementObserver.observe(announcement);
    document.documentElement.style.setProperty('--sd-sr-announcement-height', `${announcement ? announcement.getBoundingClientRect().height : 0}px`);
  };
  observeAnnouncement();
  document.addEventListener('shopify:section:load', observeAnnouncement);
  document.addEventListener('shopify:section:unload', observeAnnouncement);
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const initVideos = (scope = document) => scope.querySelectorAll('.sr-hero').forEach(hero => {
    const video = hero.querySelector('video'), toggle = hero.querySelector('[data-video-toggle]');
    if (!video || hero.dataset.ready) return;
    hero.dataset.ready = 'true';
    const update = () => { toggle.textContent = video.paused ? '▷' : 'Ⅱ'; toggle.setAttribute('aria-label', video.paused ? window.accessibilityStrings.playSlideshow : window.accessibilityStrings.pauseSlideshow); };
    if (!motion.matches) video.play().then(update).catch(update);
    else update();
    toggle.addEventListener('click', () => { if (video.paused) video.play().then(update).catch(update); else { video.pause(); update(); } });
    motion.addEventListener('change', () => { if (motion.matches) { video.pause(); update(); } });
  });
  initVideos();
  document.addEventListener('shopify:section:load', e => initVideos(e.target));
  class SomosCarousel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.sr-showcase__track');
      this.progress = this.querySelector('.sr-progress span');
      this.pauseButton = this.querySelector('[data-pause]');
      this.reduced = motion.matches;
      this.userPaused = false;
      this.resumeAt = performance.now() + 3500;
      this.position = 0;
      this.originalCards = [...this.track.children];
      this.originalCards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('a,button,[tabindex]').forEach(el => el.setAttribute('tabindex', '-1'));
        this.track.append(clone);
      });
      this.cycleWidth = () => this.track.children[this.originalCards.length].getBoundingClientRect().left - this.track.firstElementChild.getBoundingClientRect().left;
      this.abort = new AbortController();
      const listen = (el, type, fn, options = {}) => el.addEventListener(type, fn, { ...options, signal: this.abort.signal });
      const delay = () => { this.resumeAt = performance.now() + 4500; this.position = this.track.scrollLeft; };
      listen(this.track, 'pointerdown', () => { this.dragging = true; this.focused = false; delay(); }, { passive: true });
      listen(window, 'pointerup', () => { if (this.dragging) { this.dragging = false; delay(); } }, { passive: true });
      listen(window, 'pointercancel', () => { if (this.dragging) { this.dragging = false; delay(); } }, { passive: true });
      listen(this.track, 'wheel', delay, { passive: true });
      listen(this.track, 'keydown', delay);
      const resume = () => { this.position = this.track.scrollLeft; this.resumeAt = 0; };
      this.track.querySelectorAll('.sr-showcase__card').forEach(card => {
        const target = card.querySelector('a') || card.querySelector('.sr-showcase__image');
        listen(target, 'mouseenter', () => { this.hovering = matchMedia('(hover: hover)').matches; });
        listen(target, 'mouseleave', () => { this.hovering = false; resume(); });
      });
      listen(this, 'focusin', e => { this.focused = e.target.matches(':focus-visible'); });
      listen(this, 'focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; resume(); } });
      const move = direction => {
        delay();
        const card = this.track.querySelector('.sr-showcase__card');
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        this.track.scrollBy({ left: direction * step, behavior: this.reduced ? 'instant' : 'smooth' });
      };
      listen(this.querySelector('[data-prev]'), 'click', () => move(-1));
      listen(this.querySelector('[data-next]'), 'click', () => move(1));
      if (this.pauseButton) listen(this.pauseButton, 'click', () => {
        this.userPaused = !this.userPaused;
        this.pauseButton.textContent = this.userPaused ? '▷' : 'Ⅱ';
        this.pauseButton.setAttribute('aria-pressed', String(this.userPaused));
        this.pauseButton.setAttribute('aria-label', this.pauseButton.dataset[this.userPaused ? 'playLabel' : 'pauseLabel']);
        delay();
      });
      listen(motion, 'change', e => { this.reduced = e.matches; });
      listen(this.track, 'scroll', () => {
        const cycle = this.cycleWidth();
        this.progress.style.setProperty('--sd-sr-progress', `${cycle > 0 ? (this.track.scrollLeft % cycle) / cycle * 300 : 0}%`);
        if (performance.now() < this.resumeAt || this.dragging) this.position = this.track.scrollLeft;
      }, { passive: true });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: .05 });
      this.observer.observe(this);
      const tick = time => {
        const elapsed = Math.min(time - (this.lastTime || time), 50);
        this.lastTime = time;
        if (this.dataset.auto === 'true' && !(this.dataset.mobileManual === 'true' && matchMedia('(max-width: 749px)').matches) && this.visible && !document.hidden && !this.reduced && !this.userPaused && !this.dragging && !this.hovering && !this.focused && time > this.resumeAt) {
          const cycle = this.cycleWidth();
          this.position += elapsed * .024;
          if (this.position >= cycle) this.position -= cycle;
          this.track.scrollLeft = this.position;
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.observer?.disconnect(); this.originalCards?.forEach((_, index) => this.track.lastElementChild.remove()); this.ready = false; }
  }
  if (!customElements.get('somos-carousel')) customElements.define('somos-carousel', SomosCarousel);
})();


/* Finite, manual product-detail carousel; independent of the homepage autoplay. */
class SomosDetailCarousel extends HTMLElement {
  connectedCallback() {
    if (this.detailReady) return;
    this.detailReady = true;
    const track = this.querySelector('.sr-showcase__track');
    const range = this.querySelector('input[type="range"]');
    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    this.detailAbort = new AbortController();
    const signal = this.detailAbort.signal;
    const maximum = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const sync = () => {
      const max = maximum();
      range.value = max ? Math.round(track.scrollLeft / max * 1000) : 0;
      range.disabled = max < 1;
      range.style.setProperty('--sd-detail-thumb', Math.min(100, track.clientWidth / track.scrollWidth * 100) + '%');
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    };
    const move = direction => {
      const card = track.querySelector('.sr-showcase__card');
      if (!card) return;
      track.scrollBy({left:direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1), {signal});
    next.addEventListener('click', () => move(1), {signal});
    range.addEventListener('input', () => { track.scrollLeft = maximum() * Number(range.value) / 1000; }, {signal});
    track.addEventListener('scroll', sync, {passive:true,signal});
    this.detailResize = new ResizeObserver(sync);
    this.detailResize.observe(track);
    sync();
  }
  disconnectedCallback() {
    this.detailAbort?.abort();
    this.detailResize?.disconnect();
    this.detailReady = false;
  }
}
if (!customElements.get('somos-detail-carousel')) customElements.define('somos-detail-carousel', SomosDetailCarousel);
